import useApi from './useApi';

const useAdministratorsService = () => {
  const { api } = useApi();

  const getEstablishmentAdministrators = (establishmentId) => api({
    method: 'get',
    url: `/identity-access/v1/establishments/${establishmentId || 'own'}/establishment-admin-accounts`,
  });

  const getPlatformAdministrators = () => api({
    method: 'get',
    url: '/identity-access/v1/platform-admin-accounts',
  });

  const postUpdateStatus = ({ type, accountId, isActive }) => {
    const pathByType = {
      platform: 'platform-admin-accounts',
      establishment: 'establishments/own/establishment-admin-accounts',
    };

    const state = isActive ? 'activate' : 'deactivate';

    return api({
      method: 'post',
      url: `/identity-access/v1/${pathByType[type]}/${accountId}:${state}`,
    });
  };

  const postAdminAccount = ({ type, establishmentId, values }) => {
    const pathByType = {
      platform: 'platform-admin-accounts',
      establishment: `establishments/${establishmentId || 'own'}/establishment-admin-accounts`,
    };

    return api({
      method: 'post',
      url: `/identity-access/v1/${pathByType[type]}`,
      data: {
        ...values,
        passwordInitializationUrl: `${process.env.REACT_APP_URL}/reset-password?type=${type}&token=:token`,
      },
    });
  };

  const putAdminAccount = ({ type, accountId, values }) => {
    const pathByType = {
      platform: 'platform-admin-accounts',
      establishment: 'establishments/own/establishment-admin-accounts',
    };

    return api({
      method: 'put',
      url: `/identity-access/v1/${pathByType[type]}/${accountId}`,
      data: {
        ...values,
        passwordInitializationUrl: `${process.env.REACT_APP_URL}/reset-password?type=${type}&token=:token`,
      },
    });
  };

  return {
    getEstablishmentAdministrators,
    getPlatformAdministrators,
    postUpdateStatus,
    postAdminAccount,
    putAdminAccount,
  };
};

export default useAdministratorsService;
